export const transformShiftTypes = (value) => {
  if (!value || typeof value !== 'string') {
    return Array.isArray(value) ? value : [];
  }
  const cleanPattern = value.replace(/[{}]/g, '');
  return cleanPattern.split(',').map((item) => item.trim());
};

export const displayShiftTypes = (value) => {
  return transformShiftTypes(value).join(', ');
};
